{
  "newActivityNotification": "新活动通知",
  "title": {
    "SELL_ORDER_PAIRED": "订单已匹配",
    "BUY_ORDER_PAIRED": "订单已匹配",
    "BUY_ORDER_UPLOAD_PAYMENT_PROOF": "订单已付款",
    "SELL_ORDER_COMFIRMED_PAYMENT_PROOF": "订单已放币",
    "BUY_ORDER_CANCELED": "订单已取消",
    "BUY_ORDER_REQUEST_APPEAL_FROM_SELLER": "订单已提出申诉",
    "BUY_ORDER_REQUEST_APPEAL_FROM_BUYER": "订单已提出申诉",
    "SELL_ORDER_CHANGED_AMOUNT": "订单已提出修改",
    "BUY_ORDER_AGREED_CHANGE_AMOUNT": "订单修改成功",
    "BUY_ORDER_DISAGREED_CHANGE_AMOUNT": "订单修改失败",
    "SELL_ORDER_REQUEST_PAIR_CANCELED": "订单已提出取消",
    "ADMIN_APPROVED_PAIR_CANCELED": "订单已成功取消",
    "ADMIN_REJECTED_PAIR_CANCELED": "订单取消失败",
    "ADMIN_FORCE_CANCELED_PAIR": "订单已由客服取消",
    "ADMIN_FORCE_CANCELED_SELL_ORDER": "订单已由客服取消",
    "ADMIN_FORCE_CANCELED_BUY_ORDER": "订单已由客服取消",
    "ADMIN_FORCE_CONFIRMED": "订单已由客服放币",
    "ADMIN_FORCE_CHANGED_AMOUNT": "订单已由客服修改并放币",
    "USER_TRANSFERRED_PAYMENT_GATE_WAY": "支付通知",
    "USER_RECEIVED_CURRENCY": "收币通知",
    "USER_WITHDRAWAL_CURRENCY": "提币通知",
    "USER_DEPOSIT_CURRENCY": "支付通知",
    "USER_EXCHANGE_IN": "闪兑通知",
    "USER_EXCHANGE_OUT": "闪兑通知",
    "USER_RECEIVED_EXCHANGE": "闪兑通知",
    "USER_RECEIVED_PAYOUT": "收币通知",
    "ADMIN_BUY_ORDER_CANCELED": "订单已成功取消",
    "BUYER_BUY_ORDER_FORCE_CANCELED": "订单已取消",
    "ADMIN_REJECT_KYC": "身份认证审核未通过",
    "ADMIN_APPROVE_KYC": "身份认证审核通过",
    "BONUS_ACTIVITY_CREATED": "{{title}}"
  },
  "description": {
    "SELL_ORDER_PAIRED": "订单 {{orderId}} 有新的匹配。付款中订单为 {{subOrderId}}，我们会通知买家在 {{payTime}} 分钟内付款。",
    "BUY_ORDER_PAIRED": "订单 {{orderId}} 已匹配。请于 {{payTime}} 分钟内，依照卖家收款信息转帐。",
    "BUY_ORDER_UPLOAD_PAYMENT_PROOF": "订单 {{subOrderId}} 已经由买家付款，请于 10 分钟内，确认收款后点击「确认收款，放币」。",
    "SELL_ORDER_COMFIRMED_PAYMENT_PROOF": "订单 {{orderId}} 已经由卖家放币。",
    "BUY_ORDER_CANCELED": "订单 {{subOrderId}} 已经由买家取消。",
    "BUY_ORDER_REQUEST_APPEAL_FROM_SELLER": "订单 {{orderId}} 已经由卖家提出申诉，请点击「联系客服」与客服联系。",
    "BUY_ORDER_REQUEST_APPEAL_FROM_BUYER": "订单 {{subOrderId}} 已经由买家提出申诉，请点击「联系客服」与客服联系。",
    "SELL_ORDER_CHANGED_AMOUNT": "订单 {{orderId}} 已经由卖家提出修改金额，请点击「回应修改订单」。",
    "BUY_ORDER_AGREED_CHANGE_AMOUNT": "订单 {{subOrderId}} 提出的修改已经被买家接受。",
    "BUY_ORDER_DISAGREED_CHANGE_AMOUNT": "订单 {{subOrderId}} 提出的修改已经被买家拒绝，已返回「待放币」，请至订单详情确认。",
    "SELL_ORDER_REQUEST_PAIR_CANCELED": "订单 {{id}} 已经由卖家提出取消，请等待客服人员回应。",
    "ADMIN_APPROVED_PAIR_CANCELED": "订单 {{id}} 提出的取消已经被接受。",
    "ADMIN_REJECTED_PAIR_CANCELED": "订单 {{id}} 提出的取消已经被拒绝，已返回「买家付款中」，请至订单详情确认。",
    "ADMIN_FORCE_CANCELED_PAIR": "订单 {{orderId}} 已经由客服人员取消。",
    "ADMIN_FORCE_CANCELED_SELL_ORDER": "订单 {{orderId}} 已经由客服人员取消。",
    "ADMIN_FORCE_CANCELED_BUY_ORDER": "订单 {{id}} 已经由客服人员取消。",
    "ADMIN_FORCE_CONFIRMED": "订单 {{id}} 已经由客服人员放币。",
    "ADMIN_FORCE_CHANGED_AMOUNT": "订单 {{id}} 已经由客服人员修改金额并放币。",
    "USER_TRANSFERRED_PAYMENT_GATE_WAY": "支付数量 {{amount}} {{token}}",
    "USER_RECEIVED_CURRENCY": "收币数量 {{amount}} {{token}}",
    "USER_WITHDRAWAL_CURRENCY": "提币数量 {{amount}} USDT",
    "USER_DEPOSIT_CURRENCY": "支付数量 {{amount}} {{token}}",
    "USER_EXCHANGE_IN": "将 {{relatedAmount}} USDT 兑换成 {{amount}} {{token}}",
    "USER_EXCHANGE_OUT": "将 {{mount}} {{token}} 兑换成 {{amount}} USDT",
    "USER_RECEIVED_EXCHANGE": "已将收到的 {{amountOut}} USDT 兑换成 {{amount}} {{token}}",
    "USER_RECEIVED_PAYOUT": "收币数量 {{amount}} {{token}}",
    "ADMIN_BUY_ORDER_CANCELED": "订单 {{orderId}} 提出的取消已经被接受。",
    "BUYER_BUY_ORDER_FORCE_CANCELED": "订单 {{subOrderId}} 已经由买家取消。",
    "ADMIN_REJECT_KYC": "抱歉，您的审核未通过，详情请至 App 中查看。",
    "ADMIN_APPROVE_KYC": "恭喜！您的身份已通过审核。",
    "BONUS_ACTIVITY_CREATED": "{{description}}"
  }
}
